import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import LoaderComponent from "../components/LoaderComponent";
import { getUserDetailsLoading, getPermissionChangeRequests } from "../selector/selectors";
import { loadPermissionsChangeRequestList, loadUserCurrentPermissions, loadUserRequestedPermissions } from "../api/elevationapi";
import SearchBoxComponent from "../components/SearchBoxComponent";
import PermissionsChangeRequestList from "../components/PermissionsChangeRequestList";
import { Link } from "react-router-dom";
import PermissionElevationModal from "../components/PermissionElevationModal";

function ManagePermissionElevationRequest({
  isLoading,
  requestList,
  loadingPermissionChangeRequests
}) {

    const dispatch = useDispatch();
    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchValue, setSearchValue] = React.useState('');
    const [openPermissionModal, setOpenPermissionModal]   = React.useState(false);
    const [modelOpenRequestType, setModelOpenRequestType] = React.useState('');
    const permissions  =  useSelector((state) => state.elevationData.userPermissionsList);
    
    useEffect(() => {
        loadingPermissionChangeRequests('');
    }, [loadingPermissionChangeRequests]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleSearchUser = (event) => {
        setSearchValue(event.target.value);
        loadingPermissionChangeRequests(event.target.value);
      };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        loadingPermissionChangeRequests(searchValue,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        loadingPermissionChangeRequests(searchValue,0,event.target.value);
    }

    const handlePermissionDialogOpen = (id,type) => {
        setOpenPermissionModal(true);
        setModelOpenRequestType(type)
        if(type === 'current'){
            dispatch(loadUserCurrentPermissions(id));
        } else {
            dispatch(loadUserRequestedPermissions(id));
        }
    }
  
    const handlePermissionDialogClose = () => {
        setOpenPermissionModal(false);
        setModelOpenRequestType('')
    };

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/role/request-list">Role Elevation Request</Link>
                                <Tab label="Permissions Request" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'space-between'}}>
                                <SearchBoxComponent
                                handleChangeTextValue = {(e)=>handleSearchUser(e,'')}
                                label='Search Email'
                                />   
                            </Grid>
                            <PermissionsChangeRequestList 
                                requestList={requestList} 
                                page={page} 
                                rowsPerPage={rowsPerPage} 
                                handleChangeRowsPerPage={handleChangeRowsPerPage} 
                                handleChangePage={handleChangePage} 
                                handlePermissionDialogOpen={handlePermissionDialogOpen} 
                            />
                        </TabPanel>
                    </Grid>
                </TabContext>
                <PermissionElevationModal
                    open={openPermissionModal}
                    close={handlePermissionDialogClose}
                    modelOpenRequestType={modelOpenRequestType}
                    permissions={permissions}
                />
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading   :  getUserDetailsLoading(state),  
  requestList :  getPermissionChangeRequests(state),  
});

const mapDispatchToProps = (dispatch) => ({
    loadingPermissionChangeRequests: (searchValue,page,rowsPerPage) => dispatch(loadPermissionsChangeRequestList(searchValue,page,rowsPerPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagePermissionElevationRequest);

